// extracted by mini-css-extract-plugin
export default {"mCard":"uD-z","image":"vD-z","imageNoBackground":"wD-z","imageHasCategory":"xD-z","fullWidth":"yD-z"};